module.exports = __webpack_public_path__ + "img/maturity-not-cmpl.8f0e3598.svg";